var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoRecentActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 122,
    viewBox: "0 0 166 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_6705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.47 23.27H61.34",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 118.93V10.53C3 6.41001 6.34 3.07001 10.46 3.07001H155.53C159.65 3.07001 162.99 6.41001 162.99 10.53V117.24",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.52 20H109.51V26.54H146.52V20Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.33 40.13H22.66C20.8982 40.13 19.47 41.5582 19.47 43.32V57.09C19.47 58.8518 20.8982 60.28 22.66 60.28H143.33C145.092 60.28 146.52 58.8518 146.52 57.09V43.32C146.52 41.5582 145.092 40.13 143.33 40.13Z",
    stroke: "#4230E5",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.33 69.45H22.66C20.8982 69.45 19.47 70.8782 19.47 72.64V86.41C19.47 88.1718 20.8982 89.6 22.66 89.6H143.33C145.092 89.6 146.52 88.1718 146.52 86.41V72.64C146.52 70.8782 145.092 69.45 143.33 69.45Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.33 98.77H22.66C20.8982 98.77 19.47 100.198 19.47 101.96V115.73C19.47 117.492 20.8982 118.92 22.66 118.92H143.33C145.092 118.92 146.52 117.492 146.52 115.73V101.96C146.52 100.198 145.092 98.77 143.33 98.77Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_6705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 120.86,
    fill: "white",
    transform: "translate(0.5 0.570007)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecentActivity);
export default __webpack_public_path__ + "static/media/no-recent-activity.5534531d126fd41d6c019e4ff67eeac7.svg";
export { ForwardRef as ReactComponent };